import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import AdapterListMyApply from "./adapters/AdapterListMyApply";
import store from "../../../../redux/store";
import {serviceActionAddSubList, serviceActionSuccess} from "./action/ActionListMyApplysScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import {serviceActionListNotSendMyApply} from "../../splash/action/ActionSplashGetAllData";

import HMButton from "../../../../customviews/HMButton";
import HMIcon from "../../../../customviews/HMIcon";
import HMModal from "../../../../customviews/modal/HMModal";
import HMTextInput from "../../../../customviews/HMTextInput";
import HMAlert from "../../../../customviews/HMAlert";
import HMFlatList from "../../../../customviews/HMFlatList";

let container = null;
export default class ListMyApplyScreen extends Component {
    constructor(props) {
        super(props);
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }
        this.state = {

            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
        };
        container = this;

        // this.props.callserviceActionRefresh(false)
    }

    state = {
        show: false
    };

    componentWillReceiveProps(propss) {

    }

    async componentDidMount() {

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })

        let {item, data} = this.props.route.params
        item = JSON.parse(item);
        data = JSON.parse(data);

        let ListNotSendMyApply = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyApplyOffline + item.type);
        if (ListNotSendMyApply != null && ListNotSendMyApply.length > 0) {


        } else {
            ListNotSendMyApply = [];

        }
        store.dispatch(serviceActionListNotSendMyApply(ListNotSendMyApply))


        this.props.callserviceActionRefresh(false)

        if (!data.NoLogin)
            this.getData(1)

        //  this.props.callServiceAddFirst(this.props.route.params.result, this.props.item_count);
    }

    async getData(page) {
        let {item, data} = this.props.route.params;
        item = JSON.parse(item);
        data = JSON.parse(data);

        let after = "0000-00-00";
        //   this.props.callService(urlListMyApplyScreen, `?type=${this.props.typee}&city=`, TypeGetListMyApplyScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListMyApplyScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListMyApplyScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListMyApplyScreen, _GET, page, 10)
  */
        let paramss = {
            "_operation": typeExport._Contacts,

            "mode": typeExport.mode,
            "lang": i18n.locale,
            //  "token": this.props.DataSplashScreen.token,
            "token": data?.type == 7 && (data?.typeClick) ? null : this.props.DataSplashScreen.token,

            "page": page,
            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        if (data.NoLogin) {
            paramss = Object.assign(paramss,
                {
                    "trackingCode": this.state.trackingCode

                })
        }
        if (this.props.DataSplashScreen.Connection) {

            // this.props.callService(this.props.route.params.item.link_url, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyApplyScreen, _GET, page, typeExport._Count, this.props.route.params.item.id)
            //  this.props.callService(typeExport.urlListMyApplyScreen, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyApplyScreen, _GET, page, typeExport._Count, null)
            this.props.callService(typeExport.urlListMyApplyScreen, paramss, typeExport.TypeGetListMyApplyScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(`List${this.props.route.params.item.id}`)
            let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyApply + item.type)
            //this.props.callServiceSuccess(data, 0)
            if (data != null)
                store.dispatch(serviceActionSuccess(data, 0))
            else
                store.dispatch(serviceActionSuccess([], 0))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    render() {
        let {item} = this.props.route.params;
        let _params = this.props.route.params;
        let data = JSON.parse(_params.data);
        let {ListNotSendMyApply} = store.getState().reducerSplashGetAllData
        ListNotSendMyApply = ListNotSendMyApply.sort(function (a, b) {
            if (a.index > b.index) {
                return -1;
            }
            if (a.index < b.index) {
                return 1;
            }
            return 0;
        });

        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            menu
                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListMyApply.title')}
                            //text={i18n.t('ListNews.title')}
                            text={(data.name ? data.name : (data.title ? data.title : ''))}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerListMyApplyScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>

                            {
                                ListNotSendMyApply.length === 0 ?
                                    null
                                    :
                                    <TouchableOpacity
                                        onPress={() => {

                                            this.setState({visibleModal: 'ModalListNotSend'})

                                        }}
                                        style={{
                                            width: "100%",
                                            height: moderateScale(38),
                                            paddingHorizontal: moderateScale(10),
                                            backgroundColor: Colors.white,
                                            marginBottom: moderateScale(6)
                                        }}>
                                        <View

                                            style={{
                                                //  width: typeExport.WIDTH - moderateScale(40),
                                                width: "100%",

                                                height: moderateScale(38),
                                                alignSelf: 'center',
                                                // backgroundColor: 'blue',
                                                flexDirection: 'row',
                                                alignItems: 'center'
                                            }}
                                            onPress={
                                                // () => {
                                                // }
                                                this.showMenu
                                            }
                                        >
                                            <View style={{flexDirection: 'row', flex: .85}}>
                                                <HMTextView
                                                    noFont={false}
                                                    text={"*پیام های ارسال نشده*"}
                                                    numberOfLines={1}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        textAlign: 'right',
                                                        color: Colors.blackLight
                                                    }}/>
                                            </View>


                                            <View style={{flex: .10}}>
                                                <View style={{
                                                    position: 'relative',
                                                    height: moderateScale(34),
                                                    width: moderateScale(34)
                                                }}>
                                                    <HMIcon name="ios-mail" style={{
                                                        color: Colors.red,
                                                        fontSize: moderateScale(28),
                                                        padding: moderateScale(4),
                                                        alignSelf: "center",
                                                    }}/>
                                                    {
                                                        ListNotSendMyApply.length === 0 ? null :
                                                            <HMTextView text={ListNotSendMyApply.length} styleRoot={{
                                                                position: 'absolute',
                                                                overflow: 'hidden',
                                                                top: 0,
                                                                right: 0,
                                                            }} style={{

                                                                paddingLeft: ListNotSendMyApply.length < 10 ? moderateScale(6) : moderateScale(3),
                                                                paddingRight: ListNotSendMyApply.length < 10 ? moderateScale(6) : moderateScale(3),
                                                                borderRadius: moderateScale(10),
                                                                backgroundColor: Colors.colorSecondPrimary,
                                                                alignSelf: 'flex-end',
                                                                fontSize: moderateScale(10),
                                                                color: Colors.white
                                                            }}/>
                                                    }
                                                </View>
                                                {/*
                                        <Icon name={"md-arrow-dropdown"} style={{fontSize: moderateScale(22)}}/>
*/}
                                            </View>
                                        </View>
                                        {/*  <Menu
                                    ref={this.setMenuRef}
                                    style={{}}
                                    button={
                                        <TouchableOpacity

                                            style={{
                                                //  width: typeExport.WIDTH - moderateScale(40),
                                                width: "100%",

                                                height: moderateScale(38),
                                                alignSelf: 'center',
                                                // backgroundColor: 'blue',
                                                flexDirection: 'row',
                                                alignItems: 'center'
                                            }}
                                            onPress={
                                                // () => {
                                                // }
                                                this.showMenu
                                            }
                                        >
                                            <View style={{flexDirection: 'row', flex: .9}}>
                                                <HMTextView
                                                    noFont={false}
                                                    text={this.state.textMenu}
                                                    numberOfLines={1}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        textAlign: 'right',
                                                        color: Colors.blackLight
                                                    }}/>
                                            </View>


                                            <View style={{flex: .1}}>
                                                <Icon name={"md-arrow-dropdown"} style={{fontSize: moderateScale(22)}}/>
                                            </View>
                                        </TouchableOpacity>

                                        //
                                        //          <TouchableOpacity
                                        //              style={{
                                        //                  textAlign: 'center',
                                        //
                                        //                  width: moderateScale(24),
                                        //                  height: moderateScale(24),
                                        //
                                        //              }}
                                        //              onPress={this.showMenu}>
                                        //
                                        //              <Icon name="md-more"
                                        //                    style={{
                                        //                        fontSize: moderateScale(24),
                                        //                        color: Colors.white,
                                        //                        textAlign: 'center'
                                        //                    }}/>
                                        //          </TouchableOpacity>
                                        //
                                        //

                                    }
                                >
                                    {
                                        typeExport.ListMenu_ListMyApply.map((item, key) => {
                                            return (<HMMenuItem item={item} key={key} hideMenu={this.hideMenu}/>) //if you have a bunch of keys value pair

                                        })

                                    }
                                </Menu>*/}
                                    </TouchableOpacity>
                            }

                            {
                                data && data.NoLogin ?
                                    <View style={{width: "100%"}}>
                                        <View
                                            style={{
                                                height: moderateScale(42),
                                                backgroundColor: Colors.colorPrimary,
                                                flexDirection: 'row',
                                                marginHorizontal: moderateScale(10),
                                                marginTop: moderateScale(6),
                                                borderRadius: moderateScale(14),
                                                borderColor: Colors.colorDark,
                                                borderWidth: moderateScale(1),
                                                //  marginBottom: moderateScale(10)
                                                // width:'100%'
                                            }}>

                                            <View
                                                style={{
                                                    flex: .8,
                                                    height: moderateScale(40),
                                                    backgroundColor: Colors.white,
                                                    borderRadius: moderateScale(14),
                                                    flexDirection: 'row',
                                                    paddingHorizontal: moderateScale(4),
                                                    alignItems: 'center',

                                                }}>

                                                <View style={{width: moderateScale(5)}}/>

                                                <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                                    <HMTextInput value={this.state.trackingCode}
                                                                 onChangeText={(text) => this.setState({trackingCode: text}, () => {
                                                                     //  this.getJsonMap()

                                                                 })}
                                                                 _height={40}
                                                        //  autoFocus
                                                        //  placeholder={i18n.t('constant.filter')}
                                                                 placeholder={i18n.t('constant.TrackingCode') + " را جستجو نمایید "}
                                                                 NoShowPlaceholder
                                                        //باتد_width={'80%'}
                                                        // icon={"md-person"}
                                                                 style={{
                                                                     fontSize: moderateScale(13),

                                                                     // marginTop: moderateScale(6)
                                                                 }} underlineColorAndroid="transparent"/>
                                                </View>
                                                {/*{*/}
                                                {/*this.state.loadingAddressMarker ?*/}
                                                {/*<ActivityIndicator color={Colors.colorPrimary}*/}
                                                {/*size={"large"}/>*/}

                                                {/*:*/}
                                                {/*<HMTextView*/}
                                                {/*numberOfLines={1}*/}
                                                {/*onPress={() => HMAlert(*/}
                                                {/*i18n.t('constant.address'),*/}
                                                {/*this.state.addressMap,*/}
                                                {/*[*/}
                                                {/*// {text: 'Ask me later', onPress: () => {}},*/}
                                                {/*// {text: 'Cancel', onPress: () => {}, style: 'cancel'},*/}
                                                {/*{*/}
                                                {/*text: i18n.t('constant.ok'), onPress: () => {*/}
                                                {/*}*/}
                                                {/*},*/}
                                                {/*],*/}
                                                {/*{cancelable: true}*/}
                                                {/*)}*/}
                                                {/*//text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}*/}
                                                {/*text={this.state.addressMap}*/}
                                                {/*type={"bold"} style={{*/}
                                                {/*//textAlign: "center",*/}
                                                {/*color: Colors.gray,*/}
                                                {/*fontSize: moderateScale(11),*/}
                                                {/*marginEnd: moderateScale(3)*/}


                                                {/*// flex:1*/}
                                                {/*}}/>*/}
                                                {/*}*/}

                                            </View>
                                            <TouchableOpacity
                                                onPress={() => {

                                                    this.checkCode()
                                                    //  this.nextScreen(item, type)
                                                }}
                                                style={{
                                                    flex: .2,
                                                    height: moderateScale(32),
                                                    backgroundColor: Colors.colorPrimary,
                                                    borderTopEndRadius: moderateScale(14),
                                                    borderBottomEndRadius: moderateScale(14),
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>

                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={i18n.t('constant.Search')}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.white,
                                                        fontSize: moderateScale(13)

                                                    }}/>
                                            </TouchableOpacity>

                                        </View>

                                    </View>
                                    :
                                    null


                            }
                            {/*  <EmptyView empty={this.props.empty}/>*/}
                            <HMFlatList
                                showEmpty={this.props.empty}
                                data={this.props.results}
                                renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                // numColumns={2}
                                numColumns={this.state.columnCount}
                                key={this.state.columnCount}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}

                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                            />
                            {
                                // this.props.NoInternetDialog ?
                                //     <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }
                            <HMModal
                                isVisible={this.state.visibleModal === "ModalListNotSend" && ListNotSendMyApply.length > 0}
                                backdropColor={Colors.black}
                                backdropOpacity={0.9}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={this.hiddenModal}
                                onBackButtonPress={this.hiddenModal}
                            >

                                <View style={{height: "90%", backgroundColor: Colors.white}}>
                                    <FlatList
                                        style={{
                                            backgroundColor: Colors.light

                                        }}
                                        // data={this.state.arrayCity}
                                        data={ListNotSendMyApply}
                                        renderItem={this.renderItem}

                                        /*  renderItem={({item, index, separators}) => (
                                              <TouchableOpacity
                                                  style={{padding: moderateScale(10), marginHorizontal: moderateScale(10)}}
                                                  onPress={
                                                      //  onChangeItem(item,index)
                                                      () => {}

                                                          //onChangeItem(index, item)
                                                  }>
                                                  <View style={{
                                                      flexDirection: "row",
                                                      //justifyContent: "space-between",
                                                      alignItems: "center"
                                                  }}>
                                                      {/!*<Icon name="ios-arrow-back" color="#000" size={moderateScale(20)}/>*!/}
                                                      <HMTextView
                                                          noFont
                                                          type={"bold"}
                                                          text={item.name ? item.name : (item.subjects_tks_subject ? item.subjects_tks_subject : "")}
                                                          style={{
                                                              color: Colors.blackLight,
                                                              fontSize: moderateScale(16),
                                                              //  marginEnd: moderateScale(10)
                                                          }}/>
                                                  </View>
                                              </TouchableOpacity>

                                          )}*/
                                        keyExtractor={(item, index) => index.toString()}
                                        // ItemSeparatorComponent={this.renderSeparator}
                                        enableEmptySections={true}
                                    />
                                    {/*   {
                                        this.props.NoInternetDialog ?
                                            <DialogConnectionCustomize
                                                onPress={() => this.checkMobile(this.state.mobile)}
                                            />
                                            :
                                            null
                                    }*/}
                                    {

                                        //store.getState().reducerSubmitRequestScreen.isLoadingSet
                                        this.props.isLoadingSetSubmitRequestScreen
                                            ?
                                            <DialogLoadingCustomize/>
                                            : null
                                    }
                                </View>
                            </HMModal>
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    checkCode(text) {
        text = this.state.trackingCode;
        if (text == null) {

            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkCode'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
        }
        else {
            if (text.length < 6) {
                HMAlert(
                    i18n.t('constant.message'),
                    i18n.t('constant.WrongCodeEntered'),
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                            }
                        },
                    ],
                    {cancelable: true}
                )
                //alert(i18n.t('constant.WrongCodeEntered'))
            } else {
                this.getData(1)

            }
        }
    }

    renderItem = ({item, index}) => {
        return <AdapterListMyApply item={item} item_parent={this.props.route.params.item}
                                   index={index} hiddenModal={this.hiddenModal}/>;
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (this.props.DataSplashScreen.Connection) {
            this.getData(1)
        } else {
            //ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListMyApplyScreen, `?type=${this.props.typee}&city=`, TypeGetListMyApplyScreen, 'POST', 1)
    }

    renderFooter() {
        if (this.props.failed === false) {
            return (this.props.lazyload_end || this.props.page === 0) ? null :
                (
                    (this.props.showLoading || this.props.showRefresh) ?
                        <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
                        :
                        null
                )


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && this.props.DataSplashScreen.Connection) {
            // this.props.callService(urlListMyApplyScreen, `?type=${this.props.typee}&city=`, TypeGetListMyApplyScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }
}
